export type StatusPill = {
  bg: string;
  color: string;
  label: string;
  key: string;
};

const DEFAULT_BG = "#F1F5F9";
const DEFAULT_COLOR = "#475569";

const STATUS_PALETTE: Record<string, { bg: string; color: string }> = {
  booked: { bg: "rgba(79,70,229,0.12)", color: "#4F46E5" },
  confirmed: { bg: "rgba(202,138,4,0.12)", color: "#A16207" },
  latearrival: { bg: "rgba(234,88,12,0.12)", color: "#C2410C" },
  arrived: { bg: "rgba(13,148,136,0.12)", color: "#0F766E" },
  seated: { bg: "rgba(59,130,246,0.10)", color: "#2563EB" },
  completed: { bg: "rgba(22,163,74,0.10)", color: "#16A34A" },
  assigned: { bg: "rgba(22,163,74,0.10)", color: "#16A34A" },
  inqueue: { bg: "rgba(217,119,6,0.10)", color: "#D97706" },
  waiting: { bg: "rgba(217,119,6,0.10)", color: "#D97706" },
  pending: { bg: "rgba(217,119,6,0.10)", color: "#D97706" },
  cancelled: { bg: "rgba(220,38,38,0.10)", color: "#DC2626" },
  noshow: { bg: "rgba(120,53,15,0.12)", color: "#92400E" },
  lateshow: { bg: "rgba(220,38,38,0.10)", color: "#DC2626" },
  active: { bg: "rgba(210,58,59,0.10)", color: "#D23A3B" },
};

export const normalizeStatusKey = (status: unknown): string =>
  String(status ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const formatStatusLabel = (status: unknown): string => {
  const raw = String(status ?? "").trim();
  if (normalizeStatusKey(raw) === "noshow") return "No-Show";
  if (!raw) return "—";
  return raw
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
};

export const getStatusPill = (status: unknown): StatusPill => {
  const raw = String(status ?? "").trim();
  const key = normalizeStatusKey(raw);
  const label = formatStatusLabel(raw);

  if (STATUS_PALETTE[key]) {
    return { ...STATUS_PALETTE[key], label, key };
  }

  if (/seated|assigned|completed|seat/.test(key)) {
    return { bg: STATUS_PALETTE.completed.bg, color: STATUS_PALETTE.completed.color, label, key };
  }
  if (/waiting|inqueue|queue|pending/.test(key)) {
    return { bg: STATUS_PALETTE.waiting.bg, color: STATUS_PALETTE.waiting.color, label, key };
  }
  if (/cancel|noshow|walkaway|late/.test(key)) {
    return { bg: STATUS_PALETTE.cancelled.bg, color: STATUS_PALETTE.cancelled.color, label, key };
  }
  if (/active/.test(key)) {
    return { bg: STATUS_PALETTE.active.bg, color: STATUS_PALETTE.active.color, label, key };
  }

  return { bg: DEFAULT_BG, color: DEFAULT_COLOR, label, key };
};

